import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const isPortfolio = location.pathname.includes("portfolio");

  return (
    <header className="text-center space-y-4">
      <h1 className="text-4xl text-zinc-300 md:text-5xl font-bold">Gary Pinkley</h1>
      <p>AI Engineer | HCI Specialist | Software Developer | Data Analyst</p>
      
      <div className="pt-4">
        <Link
          to={isPortfolio ? "/" : "/portfolio"}
          className="inline-block bg-zinc-800 border border-zinc-700 px-4 py-2 rounded hover:bg-zinc-700"
        >
          {isPortfolio ? "Back to About Me" : "View Portfolio Page"}
        </Link>
      </div>
    </header>
  );
}
